"use client";

import React, { createContext, useContext, useEffect, useState } from "react";
import { BASE_URL } from "../config/apiconfig";

const SupplierTypesContext = createContext();

export const SupplierTypesProvider = ({ children }) => {
  const [supplierTypes, setSupplierTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  const getHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  });

  /* GET ALL */
  const fetchSupplierTypes = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/supplier-types`, {
        headers: getHeaders(),
      });

      const json = await res.json();
      if (json.status === 200) {
        setSupplierTypes(json.data);
      }
    } catch (err) {
      console.error("Fetch Supplier Types Error:", err);
    } finally {
      setLoading(false);
    }
  };

  /* CREATE */
  const addSupplierType = async (data) => {
    const res = await fetch(`${BASE_URL}/supplier-types`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(data),
    });

    const json = await res.json();
    await fetchSupplierTypes();
    return json;
  };

  /* UPDATE */
  const updateSupplierType = async (id, data) => {
    const res = await fetch(`${BASE_URL}/supplier-types/${id}`, {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify(data),
    });

    const json = await res.json();
    await fetchSupplierTypes();
    return json;
  };

  /* DELETE */
  const deleteSupplierType = async (id) => {
    await fetch(`${BASE_URL}/supplier-types/${id}`, {
      method: "DELETE",
      headers: getHeaders(),
    });

    setSupplierTypes((prev) => prev.filter((s) => s.id !== id));
  };

  /* STATUS */
  const toggleSupplierTypeStatus = async (id) => {
    await fetch(`${BASE_URL}/supplier-types/${id}/status`, {
      method: "PUT",
      headers: getHeaders(),
    });

    await fetchSupplierTypes();
  };

  useEffect(() => {
    fetchSupplierTypes();
  }, []);

  return (
    <SupplierTypesContext.Provider
      value={{
        supplierTypes,
        loading,
        fetchSupplierTypes,
        addSupplierType,
        updateSupplierType,
        deleteSupplierType,
        toggleSupplierTypeStatus,
      }}
    >
      {children}
    </SupplierTypesContext.Provider>
  );
};

export const useSupplierTypes = () => useContext(SupplierTypesContext);